import React from "react";
export const Disobedience = () => {
  return (
    <div className="opinion-wrap">
      <h1>对处理意见不服怎么办？</h1>
      <div className="text-cont">
        &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;根据《信访工作条例》第三十五条规定，信访人对信访处理意见不服的，可以自收到书面答复之日起30日内请求原办理单位、部门的上一级机关、单位复查。收到复查请求的单位、部门应当自收到复查请求之日起30日内提出复查意见，并予以书面答复。
      </div>

      <br />
    </div>
  );
};
